import { FormInput, FormQuerySelector, Modal } from "@vesatogo/grass-core"
import { FileUpload } from "@vesatogo/grass-dropzone"
import { useEffect, useState } from "react"
import toast from "react-hot-toast"
import { useSearchParams } from "react-router-dom"
import { v4 as uuid4 } from "uuid"
import { CustomToast } from "~/components/CustomToast"
import { useAllFinancialYearsQuery } from "~/generated/graphql"

const INITIAL_STATE = {
  attachments: [],
  financial_year: undefined,
  capital: undefined,
  fixed_assets: undefined,
  current_liabilities: undefined,
  current_assets: undefined,
  profit_loss: undefined,
  total_sales: undefined,
}
export const AddBalanceSheet = ({ form, isDisabled = false }) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const balanceSheet = searchParams.get("balance_sheet")
  const onClose = () => {
    searchParams.delete("balance_sheet")
    setSearchParams(searchParams, { relative: "route" })
    setBal(INITIAL_STATE)
  }

  const [bal, setBal] = useState(INITIAL_STATE)
  const [submitted, setSubmitted] = useState(false)

  useEffect(() => {
    if (balanceSheet) {
      const currBal = form.values?.financial_year_assessments?.find(bal => {
        const id = bal?.id || bal?._id
        return id == balanceSheet
      })
      setBal(currBal)
    }
  }, [balanceSheet])

  const years = form.values?.financial_year_assessments?.map(
    fin => fin?.year?.id
  )
  return (
    <Modal
      onClose={onClose}
      isOpen={Boolean(balanceSheet)}
      title="Financial Assessment"
      bodyClassName="max-w-4xl"
      primaryActionButtonProps={{
        text: "Yes, Confirm",
        onClick: () => {
          setSubmitted(true)
          if (
            !bal?.financial_year ||
            !bal?.capital ||
            !bal?.current_assets ||
            !bal?.current_liabilities ||
            !bal?.fixed_assets ||
            !bal?.profit_loss ||
            !bal?.total_sales
          ) {
            return CustomToast({
              title: "Please enter all mandatory values!",
              intent: "danger",
            })
          }
          if (!bal?.attachments?.length) {
            return CustomToast({
              title: "Please upload attachments!",
              intent: "danger",
            })
          }
          if (balanceSheet === "true") {
            //Add New
            const currBal = form?.values?.financial_year_assessments || []
            const newBalance = [...currBal, { ...bal, _id: uuid4() }]
            const updatedState = {
              ...form.values,
              financial_year_assessments: newBalance,
            }
            form.setValues(updatedState)
          } else {
            //Update Existing
            const currBal = form?.values?.financial_year_assessments || []
            const newBalance = currBal.map(entry => {
              const id = entry?.id || entry?._id
              return id == balanceSheet ? { ...entry, ...bal } : entry
            })
            const updatedState = {
              ...form.values,
              financial_year_assessments: newBalance,
            }
            form.setValues(updatedState)
          }
          onClose()
          setSubmitted(false)
        },
      }}
      secondaryActionButtonProps={{
        text: "Cancel",
        onClick: onClose,
      }}
    >
      <section className="grid grid-cols-4">
        <div>
          <FileUpload
            media={bal?.attachments || []}
            onChange={e => {
              setBal(val => ({ ...val, attachments: e }))
            }}
            maxFiles={1}
            onError={toast.error}
            endpoint={`https://${
              import.meta.env.VITE_REST_URL
            }/rest/trade/uploader/`}
            appName="setutrade"
            onSuccess={(file: any) => {
              setBal(val => ({
                ...val,
                attachments: [file[0]?.data?.media] as any,
              }))
            }}
            disabled={isDisabled}
          />
        </div>
        <div className="col-span-3 grid grid-cols-2 gap-3">
          <FormQuerySelector
            label="Financial Year"
            required
            dataHook={useAllFinancialYearsQuery}
            serverSideQuery
            value={bal?.financial_year}
            onChange={e => {
              setBal(val => ({ ...val, financial_year: e }))
            }}
            filterOption={(op: any) => {
              return !years?.includes(op?.data?.id)
            }}
            error={
              submitted && !bal?.financial_year ? "Please Select Year" : ""
            }
            disabled={isDisabled}
          />
          <FormInput
            label="Capital"
            required
            value={bal?.capital}
            onChange={e => {
              setBal(val => ({ ...val, capital: e }))
            }}
            error={submitted && !bal?.capital ? "Please Enter Capital" : ""}
            disabled={isDisabled}
          />
          <FormInput
            label="Fixed Assets"
            required
            value={bal?.fixed_assets}
            onChange={e => {
              setBal(val => ({ ...val, fixed_assets: e }))
            }}
            error={
              submitted && !bal?.fixed_assets ? "Please Enter Fixed Assets" : ""
            }
            disabled={isDisabled}
          />
          <FormInput
            label="Current Liabilities"
            required
            value={bal?.current_liabilities}
            onChange={e => {
              setBal(val => ({ ...val, current_liabilities: e }))
            }}
            error={
              submitted && !bal?.current_liabilities
                ? "Please Enter Liabilities"
                : ""
            }
            disabled={isDisabled}
          />
          <FormInput
            label="Current Assets"
            required
            value={bal?.current_assets}
            onChange={e => {
              setBal(val => ({ ...val, current_assets: e }))
            }}
            error={
              submitted && !bal?.current_assets ? "Please Enter Assets" : ""
            }
            disabled={isDisabled}
          />
          <FormInput
            label="Profit / Loss"
            required
            value={bal?.profit_loss}
            onChange={e => {
              setBal(val => ({ ...val, profit_loss: e }))
            }}
            error={
              submitted && !bal?.profit_loss ? "Please Enter Profit/Loss" : ""
            }
            disabled={isDisabled}
          />
          <FormInput
            label="Total Sales"
            required
            className={"col-span-2"}
            value={bal?.total_sales}
            onChange={e => {
              setBal(val => ({ ...val, total_sales: e }))
            }}
            error={
              submitted && !bal?.total_sales ? "Please Enter Total Sales" : ""
            }
            disabled={isDisabled}
          />
        </div>
      </section>
    </Modal>
  )
}
